export const BUNDLE_CARD_TEST_ID = 'bundle-card';
export const BUNDLE_CARD_TITLE_TEST_ID = 'bundle-card-title';
export const BUNDLE_CARD_CATEGORY_TEST_ID = 'bundle-card-category';
export const BUNDLE_CARD_IMAGE_TEST_ID = 'bundle-card-image';